import React from "react";
import { Modal } from "antd";
import { toast } from "react-toastify";
import { clientLogin } from "../event-management/EventApis";

function GlobalLoginModal({ isOpen, onClose, onLoginSuccess, onLoginEntrySuccess, matchedUser }) {
  const [progress, setProgress] = React.useState(0);
  const handleEntryRef = React.useRef(null);

  const handleEntry = async () => {
    if (!matchedUser) return;
    
    try {
      const response = await clientLogin(
        matchedUser.clientId,
        matchedUser.name,
        matchedUser.serialNumber || "", 
        "fingerprint"
      );

      if (response.success) {
        if (onLoginSuccess) {
           onLoginSuccess();
        }
        if (onLoginEntrySuccess) {
           onLoginEntrySuccess(matchedUser.clientId);
        }
        onClose();
      } else {
        toast.error(response.message || "Failed to record entry.");
      }
    } catch (error) {
      toast.error("Network error while recording entry.");
      console.error(error);
    }
  };

  handleEntryRef.current = handleEntry;

  React.useEffect(() => {
    let interval;
    if (isOpen && matchedUser) {
      setProgress(0);
      interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 100) {
            clearInterval(interval);
            if (handleEntryRef.current) {
              handleEntryRef.current();
            }
            return 100;
          }
          return prev + 1; // 1% every 50ms = 5 seconds total
        });
      }, 50);
    } else {
      setProgress(0);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isOpen, matchedUser]);

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered
      width={600}
      destroyOnClose
    >
      <div className="w-100">
        {matchedUser && (
          <div className="w-100 bg-white" style={{ borderRadius: "8px", overflow: "hidden" }}>
            <div className="w-100">
              <div className="d-flex p-4 border-bottom align-items-center">
                <div className="me-4 flex-shrink-0" style={{ border: "2px solid #3778ba", padding: "4px", borderRadius: "8px" }}>
                  {matchedUser.photo ? (
                    <img 
                      src={matchedUser.photo} 
                      alt="Profile" 
                      className="rounded" 
                      style={{ width: 140, height: 160, objectFit: "cover" }} 
                    />
                  ) : (
                    <div className="rounded bg-secondary d-flex justify-content-center align-items-center text-white fs-1" style={{ width: 140, height: 160 }}>
                      {matchedUser.name.charAt(0)}
                    </div>
                  )}
                </div>
                
                <div className="text-start flex-grow-1">
                  <h3 className="card-title fw-bold text-dark mb-3">{matchedUser.name}</h3>
                  
                  <div className="mb-2 d-flex">
                    <span className="text-muted fw-bold" style={{ width: '100px' }}>UCC:</span>
                    <strong className="text-dark">{matchedUser.uccNumber || 'N/A'}</strong>
                  </div>
                  
                  <div className="mb-2 d-flex">
                    <span className="text-muted fw-bold" style={{ width: '100px' }}>APP:</span>
                    <strong className="text-dark">{matchedUser.applicationNo || 'N/A'}</strong>
                  </div>
                  
                  <div className="mb-2 d-flex">
                    <span className="text-muted fw-bold" style={{ width: '100px' }}>Email:</span>
                    <strong className="text-dark text-truncate" style={{ maxWidth: '200px' }}>{matchedUser.email || 'N/A'}</strong>
                  </div>
                  
                  <div className="mb-2 d-flex">
                    <span className="text-muted fw-bold" style={{ width: '100px' }}>Telephone:</span>
                    <strong className="text-dark">{matchedUser.telephone || 'N/A'}</strong>
                  </div>
                  
                  <div className="d-flex">
                    <span className="text-muted fw-bold" style={{ width: '100px' }}>Client:</span>
                    <strong className="text-dark text-capitalize">{matchedUser.type.replace(/([A-Z])/g, ' $1').trim()}</strong>
                  </div>
                </div>
              </div>
              
              <div className="p-3 d-flex justify-content-between align-items-center bg-light">
                 <div className="fw-bold text-dark fs-6">
                   Renewal Date: <span className="ms-2">{matchedUser.renewalDate ? new Date(matchedUser.renewalDate).toLocaleDateString('en-GB') : 'N/A'}</span>
                 </div>
                 <div className="d-flex gap-2">
                    <button className="btn btn-outline-secondary px-4 py-2 fw-bold" onClick={onClose}>
                      Cancel
                    </button>
                    <button 
                      className="btn px-4 py-2 position-relative overflow-hidden" 
                      style={{ backgroundColor: "#e9ecef", border: "none", minWidth: "140px" }} 
                      onClick={handleEntry}
                    >
                      <div 
                        className="position-absolute top-0 start-0 h-100" 
                        style={{ backgroundColor: "#3778ba", width: `${progress}%`, transition: "width 0.05s linear" }}
                      ></div>
                      <span className="position-relative fw-bold" style={{ color: progress > 50 ? "#fff" : "#333", zIndex: 1 }}>
                        Entry ({Math.ceil(5 - (progress / 20))}s)
                      </span>
                    </button>
                 </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
}

export default GlobalLoginModal;
